function processRawTranslation(arrayOfTranslations = []){
  let result = {}

  for (let index = 0; index < arrayOfTranslations.length; index++) {
    const translation = arrayOfTranslations[index];
    const { category, key, en, id } = translation

    if(!result[category]){
      result[category] = {}
    }

    if(!result[category][key]){
      result[category][key] = {}
    }

    result[category][key].en = en
    result[category][key].id = id
  }

  return result
}

export { processRawTranslation }
